import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData} from '../../../services/management/accommodation/accommodationServices';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';


const WaitingAccommodation = () => {
  const [dataList, setDataList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  
  
  const fetchData = useCallback(async () => {
    try {
      const data = await getData({ verified: "WAITING" });
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);

  

  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true); 
      await fetchData();
      // Optional 2 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false); 
    };
  
    fetchDataAsync();
  }, [fetchData]);

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

 

  // Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    return dataList.filter((data) => 
    data.first_name.toLowerCase().includes(searchText.toLowerCase()) ||
    data.last_name.toLowerCase().includes(searchText.toLowerCase()) ||
    data.sub_domain.toLowerCase().includes(searchText.toLowerCase()) ||
    data.hotel_name.toLowerCase().includes(searchText.toLowerCase()) ||
    data.venue.toLowerCase().includes(searchText.toLowerCase()) ||
    data.conf_shortname.toLowerCase().includes(searchText.toLowerCase()) ||
    data.accompany_name.toLowerCase().includes(searchText.toLowerCase())
  )
  .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)); // Descending by updatedAt
  }, [dataList, searchText]);

  const columns = [
    {
        name: '#',
        selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
        sortable: false,
        width: '80px',
    },
    {
        name: 'Date',
        selector: (row) => row.updatedAt,
        sortable: true,
    },
    {
    name: 'Series',
    selector: (row) => {
        // Assuming the `series` field is in format like "2025-11" or "2025-11-15"
        const date = new Date(row.series);
        
        // Format as "2025-11 Nov 2025"
        const year = date.getFullYear();
        const month = date.getMonth(); // 0-based index, so we add 1
        const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
    
        return ` ${months[month]} ${year}`;
    },
    sortable: true,
    },
    {
        name: 'Shortname',
        selector: (row) => row.conf_shortname,
        sortable: true,
    },
    {
        name: 'First Name',
        selector: (row) => row.first_name,
        sortable: true,
    },
    {
        name: 'Last Name',
        selector: (row) => row.last_name,
        sortable: true,
    }   
    
            
  ];

  // Function to render expandable row details
  const ExpandableRow = ({ data }) => {

    return (
      <div className="p-3 bg-light border">
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td><b>Payment ID:</b></td>
               <td>
                {Array.isArray(data.pr_id)
                  ? data.pr_id.join(", ")
                  : data.pr_id}
              </td>
            </tr> 
            <tr>
              <td><b>Accommodation status:</b></td>
              <td>{data.accommodation_status}</td>
            </tr>
            <tr>
              <td><b>Occupancy:</b></td>
              <td>{data.occupancy}</td>
            </tr>
            <tr>
              <td><b>No of Nights:</b></td>
              <td>{data.no_of_nights}</td>
            </tr>
             {data.accompany_name && (
                <tr>
                  <td><b>Accompany Name</b></td>
                  <td>{data.accompany_name}</td>
                </tr>
              )}
             <tr>
          </tr>
          </tbody>
        </table>
      </div>
    );
  };
  
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: "300px" }}
          >
            <Spinner/>
          </div>
                  ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className="fs-4">Conference Management / Accommodation / Waiting Accommodation</p>
            </div>
          </div>

          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText} onChange={handleSearchChange} />
              </div>
            }
            expandableRows
            expandableRowsComponent={ExpandableRow}  // ✅ Adding expandable row
          />
        </div>
        <Footer />
        </div>
        )}
      </div>
    </div>
  );
};

export default WaitingAccommodation;
